import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})

export class TransaccionesService {

  constructor(
    private http: HttpClient
  ) {}

  getJson( url ) {
    const headers = new HttpHeaders({
      'Content-Type':'application/json',
      'fechaIni' : url[1], 
      'fechaFin' : url[2]
    });
    return this.http.get(url[0], {headers})
  }

}
